import { FC, useEffect, useState } from 'react';
import { geocodingServices } from 'src/services';
import { GoogleMap, useJsApiLoader } from '@react-google-maps/api';
import { googleMapConfig } from 'src/app-config';
import { Loading, MapMarkerCurrentPosition } from 'src/components/_commons';
import { Modal } from 'react-bootstrap';
import { setAlertResponse } from 'src/store';
import { typeCoords } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetConfig, useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';

type propsType = {
    address: string;
    hideGoogleMapHandler: () => void;
};
 
export const MapModalTeleph: FC<propsType> = ({ address, hideGoogleMapHandler }) => {
    const config = useGetConfig();
    //
    const [centerCoords, setCenterCoords] = useState<typeCoords | null>(null);
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    const mapLoader = useJsApiLoader(googleMapConfig);

    useEffect(() => {
        const target = `${address}, ${config.congregationArea ?? 'Argentina'}`;
        geocodingServices.GetCoordinatesFromAddress(target).then(response => {
            if (!response.success || !response.data?.coordinates?.lat || !response.data.coordinates.lng) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setCenterCoords({
                lat: response.data.coordinates.lat,
                lng: response.data.coordinates.lng
            });
        });
    }, [address]);

    return (
        <Modal show size={'lg'} fullscreen={'md-down'} onHide={hideGoogleMapHandler}>
            <Modal.Header className={isDarkMode ? 'bg-dark text-white' : ''} closeButton>
                <Modal.Title>
                    {address}, {config.congregationArea ?? 'Argentina'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-lightdark text-white' : ''}>
                {mapLoader.isLoaded && centerCoords ?
                    <GoogleMap
                        center={centerCoords}
                        id={googleMapConfig.id}
                        mapContainerClassName={'d-block m-auto'}
                        mapContainerStyle={{
                            height: isMobile ? '600px' : '700px',
                            width: '93%'
                        }}
                        zoom={17.8}
                    >
                        <MapMarkerCurrentPosition
                            position={centerCoords}
                            showError
                        />
                    </GoogleMap>
                    :
                    <Loading mt={'40px'} mb={'40px'} />
                }
            </Modal.Body>
        </Modal>
    );
}
